import { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
export default function App() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    age: "",
    gender: "",
    symptoms: ""
  });

  const [errors, setErrors] = useState({});
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

const validate = () => {
  let newErrors = {};
  let missingFields = [];

  if (!form.name.trim()) {
    newErrors.name = "Name is required";
    missingFields.push("name");
  }

  if (!form.email) {
    newErrors.email = "Email is required";
    missingFields.push("email");
  }

  if (!form.age) {
    newErrors.age = "Age is required";
    missingFields.push("age");
  }

  if (!form.gender) {
    newErrors.gender = "Gender is required";
    missingFields.push("gender");
  }

  if (!form.symptoms) {
    newErrors.symptoms = "Symptoms are required";
    missingFields.push("symptoms");
  }

  setErrors(newErrors);

  return {
    isValid: Object.keys(newErrors).length === 0,
    missingFields
  };
};

useEffect(() => {
  const vids = [
    "/error-missing-fields.mp4",
    "/success-submitted.mp4"
  ];

  vids.forEach(src => {
    const v = document.createElement("video");
    v.src = src;
  });
}, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


const handleSubmit = () => {
  const { isValid, missingFields } = validate(); // ✅ FIXED

  setLoading(true);

  const nextVideo = isValid
    ? "/success-submitted.mp4"
    : "/error-missing-fields.mp4";

setTimeout(() => {
    const video = document.createElement("video");
    video.src = nextVideo;

    video.onloadeddata = () => {
      setVideoUrl(nextVideo);
      setLoading(false);

      if (isValid) {
        // ✅ Toast success
        toast.success("Data submitted successfully!");

        // ✅ Clear form
        setForm({
          name: "",
          email: "",
          age: "",
          gender: "",
          symptoms: ""
        });
        setErrors({});
      } else {
        // ❌ Toast error
        // toast.error("Please fill all required fields");
      }

      setTimeout(() => {
        setVideoUrl("");
      }, 8000);
    };
  }, 2000);
  if (isValid) {
  setSubmitted(true);
}
// if (!isValid) {
//   toast.error(`Missing: ${missingFields.join(", ")}`);
// }
};


  return (
    
    <div className="container">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#1f2937",
            color: "#fff",
            borderRadius: "10px",
            padding: "12px 16px"
          }
        }}
      />
      {/* {!submitted ? ( */}
      <div className="form-section">
        <h2>Patient Information</h2>

        <div className="field">
          <label>Name</label>
          <input 
          name="name" 
          value={form.name}
          onChange={handleChange} />
          {errors.name && <span>{errors.name}</span>}
        </div>

        <div className="field">
          <label>Email</label>
          <input name="email" value={form.email} onChange={handleChange} />
          {errors.email && <span>{errors.email}</span>}
        </div>

        <div className="field">
          <label>Age</label>
          <input name="age" value={form.age} type="number" onChange={handleChange} />
          {errors.age && <span>{errors.age}</span>}
        </div>

        <div className="field">
          <label>Gender</label>
          <select name="gender" onChange={handleChange}>
            <option value="">Select</option>
            <option>Male</option>
            <option>Female</option>
          </select>
          {errors.gender && <span>{errors.gender}</span>}
        </div>

        <div className="field">
          <label>Symptoms</label>
          <textarea name="symptoms" value={form.symptoms} rows="3" onChange={handleChange} />
          {errors.symptoms && <span>{errors.symptoms}</span>}
        </div>

        <button onClick={handleSubmit}>Submit</button>
      </div>
        {/* ) : (
        <div className="form-section success-state">
          <h2>✅ Data Submitted</h2>
          <p>Your information has been successfully recorded.</p>
        </div>
      )} */}
       <div className="avatar-section">

  {/* Idle Video (always present) */}
  <video
    autoPlay
    loop
    muted
    playsInline
    className={`avatar-video ${videoUrl ? "fade-out" : "fade-in"}`}
  >
    <source src="/idle-doctor.mp4" type="video/mp4" />
  </video>

  {/* Response Video (on top) */}
  {videoUrl && (
    <video
      autoPlay
      className="avatar-video overlay-video fade-in"
    >
      <source src={videoUrl} type="video/mp4" />
    </video>
  )}

  {/* Loading Overlay */}
  {loading && (
    <div className="overlay-text">
      🧠 Doctor is reviewing your information...
    </div>
  )}

</div>
    </div>
  );
}